import React from 'react';
import Rating from '@mui/material/Rating';
import Grid from '@mui/material/Grid';
import { ImageEndPoint } from 'config/config';
import MapView from 'components/MapView';
import Collapse from '@mui/material/Collapse';
import HelpedComment from './HelpedComment';

function PostCard({ data }) {
  const [value, setValue] = React.useState(2);
  const [expanded, setExpanded] = React.useState(false);

  console.log(data);
  const handleExpandClick = (id) => {
    // setExpanded(!expanded);

    setExpanded({
      ...expanded,
      [id]: !expanded[id],
    });
  };

  return (
    <>
      {data.map((item, i) => (
        <Grid item lg={12} md={12} sm={12} xs={12}>
          <div className='bg-white shadow rounded-lg  w-full border-opacity-100 overflow-hidden border border-color-btn'>
            <div className='flex flex-row border-b p-4	border-color-btn '>
              <img
                id='output'
                src={ImageEndPoint + item.symptons.image}
                className='w-12 h-12 rounded-full object-cover'
                alt=''
              />
              <div className='mx-4'>
                <div className='text-base font-semibold text-black'>
                  {item.symptons.name}
                </div>
                <div className='text-xs text-color-btn'>
                  {item.Isincognito ? 'Inkognitomodus' : item.user.fname}
                  <span className='text-xs text-color-yellow ml-4 '>
                    &#8226;
                  </span>
                  <span className='text-[12px] text-color-grey ml-2 '>
                    just now
                  </span>
                </div>
              </div>
            </div>

            {item.whatHelped === '1' || item.whatHelped === '2' ? (
              <>
                <div className='p-4'>
                  <div className='flex flex-row  justify-between'>
                    <div className='text-base font-semibold text-color-btn my-2'>
                      {item.means_thearay[0].name}
                    </div>
                    <div>
                      <i class='fas fa-share text-color-btn'></i>
                    </div>
                  </div>

                  <img
                    class='w-full h-64 rounded-lg object-cover overflow-auto  '
                    src={ImageEndPoint + item.means_thearay[0].image}
                    alt='card'
                  />

                  <div className='test-base text-black mt-2'>
                    {item.means_thearay[0].desc}
                  </div>
                </div>
              </>
            ) : item.whatHelped === '3' ? (
              <>
                <div className='p-4'>
                  <div className='flex flex-row  justify-between'>
                    <div className='text-base font-semibold text-color-btn my-2'>
                      {item.professional_other.name}
                    </div>
                    <div>
                      <i class='fas fa-share text-color-btn'></i>
                    </div>
                  </div>

                  <MapView
                    lat={item.professional_other.lat}
                    lng={item.professional_other.long}
                  />
                  <div className='test-base text-black my-4'>
                    {item.professional_other.address}
                  </div>
                </div>
              </>
            ) : item.whatHelped === '4' ? (
              <>
                <div className='p-4'>
                  <div className='flex flex-row  justify-between'>
                    <div className='text-base font-semibold text-color-btn my-2'>
                      {item.professional_other.name}
                    </div>
                    <div>
                      <i class='fas fa-share text-color-btn'></i>
                    </div>
                  </div>

                  <div className='h-6' />
                  <div className='test-base text-black my-4'>
                    {/* {item.professional_other.address} */}
                  </div>
                </div>
              </>
            ) : null}

            {/* 
            <div className='p-4'>
              <div className='flex flex-row  justify-between'>
                <div className='text-base font-semibold text-color-btn'>
                  kname
                </div>
                <div>
                  <i class='fas fa-share text-color-btn'></i>
                </div>
              </div>

              <img
                class='w-full h-64 rounded-lg object-cover overflow-auto  '
                src={
                  'https://img.freepik.com/free-vector/medicine-flat-design_1212-670.jpg?t=st=1647372440~exp=1647373040~hmac=282d1c2d31c3b75a913a4c8e617fcbb20500610e5e4d10812d88c5202d7f0fce&w=740'
                }
                alt='card'
              />
              <MapView lat={-3.745} lng={-38.523} />
              <div className='test-base text-black my-4'>adasd</div>
            </div>
 */}

            <div className='flex flex-row  justify-between p-4'>
              <button onClick={() => handleExpandClick(i)}>
                <i class='fas fa-heart text-color-yellow text-base' />
                <span className='text-color-btn test-xs mx-2'>half Dir</span>
              </button>

              <div>
                <Rating name='read-only' value={value} readOnly size='small' />
              </div>
            </div>
            <Collapse in={expanded[i]} timeout='auto' unmountOnExit>
              <HelpedComment />
            </Collapse>
          </div>
        </Grid>
      ))}
    </>
  );
}

export default PostCard;
